class Podcast {
  container: HTMLElement;
  audio: HTMLAudioElement;
  playBtn: HTMLButtonElement;
  speedBtn: HTMLButtonElement;
  backBtn: HTMLButtonElement;
  forwardBtn: HTMLButtonElement;
  progress: HTMLInputElement;
  currentTime: HTMLElement;
  durationTime: HTMLElement;

  constructor(container: HTMLElement) {
    this.container = container;

    this.audio = container.querySelector<HTMLAudioElement>(".podcast__media")!;
    this.playBtn =
      container.querySelector<HTMLButtonElement>(".podcast__play")!;
    this.backBtn =
      container.querySelector<HTMLButtonElement>(".podcast__back")!;
    this.speedBtn =
      container.querySelector<HTMLButtonElement>(".podcast__speed")!;
    this.forwardBtn =
      container.querySelector<HTMLButtonElement>(".podcast__forward")!;
    this.progress =
      container.querySelector<HTMLInputElement>(".podcast__progress")!;
    this.currentTime =
      container.querySelector<HTMLElement>(".podcast__current")!;
    this.durationTime =
      container.querySelector<HTMLElement>(".podcast__duration")!;

    this.init();
  }

  init() {
    const setMetadata = () => {
      if (Number.isFinite(this.audio.duration) && this.audio.duration > 0) {
        this.progress.max = this.audio.duration.toString();
        this.updateTime();
      }
    };
    this.audio.addEventListener("loadedmetadata", setMetadata);
    this.audio.addEventListener("durationchange", setMetadata);

    this.playBtn.addEventListener("click", () => {
      if (this.audio.paused) {
        this.audio.play();
        this.playBtn.textContent = "❚❚";
      } else {
        this.audio.pause();
        this.playBtn.textContent = "▶";
      }
    });

    this.backBtn.addEventListener("click", () => this.seekBy(-15));
    this.forwardBtn.addEventListener("click", () => this.seekBy(15));

    this.audio.addEventListener("timeupdate", () => {
      if (Number.isFinite(this.audio.duration)) {
        this.progress.value = this.audio.currentTime.toString();
      }
      this.updateTime();
    });

    this.progress.addEventListener("input", () => {
      this.audio.currentTime = Number(this.progress.value);
      this.updateTime();
    });

    this.audio.addEventListener("ended", () => {
      this.playBtn.textContent = "▶";
      this.progress.value = "0";
      this.updateTime();
    });

    const speeds = [1, 1.5, 2]; 
    let currentSpeedIndex = 0; 

    this.speedBtn.addEventListener("click", () => {
      currentSpeedIndex = (currentSpeedIndex + 1) % speeds.length;
      const newSpeed = speeds[currentSpeedIndex];

      this.audio.playbackRate = newSpeed;
      this.speedBtn.textContent = newSpeed.toFixed(1) + " x";
    });
  }

  private updateTime() {
    const current = this.audio.currentTime;
    const remaining = this.audio.duration - current;

    if (!Number.isFinite(current) || !Number.isFinite(remaining)) {
      this.currentTime.textContent = "0:00";
      this.durationTime.textContent = "-0:00";
      return;
    }

    this.currentTime.textContent = this.formatTime(current);
    this.durationTime.textContent = "-" + this.formatTime(remaining);
  }

  private formatTime(seconds: number): string {
    if (!Number.isFinite(seconds) || seconds < 0) return "0:00";
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${mins}:${secs < 10 ? "0" : ""}${secs}`;
  }

  private seekBy(seconds: number) {
    if (!Number.isFinite(this.audio.duration)) return;

    this.audio.currentTime = Math.max(
      0,
      Math.min(this.audio.duration, this.audio.currentTime + seconds),
    );
  }
}

document.querySelectorAll<HTMLElement>(".podcast").forEach((podcastEl) => {
  new Podcast(podcastEl);
});
